<template>
  <div class="container">
    <div @click="goback()">
      <div class="navi">
          <span class="icon-arrow-left"></span>
      </div>
    </div>
    
    <div class="title">费用详情</div>
    <div class="weui-form-preview"  v-if="orderDetail.payment_amount>0 || orderDetail.order_amount>20">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label color-black">总费用</label>
                  <em class="weui-form-preview__value color-orange" v-if="orderDetail.pay_status==2">{{Number(orderDetail.payment_amount)+Number(orderDetail.deposit_amount) | numeral('$0,0.00')}}</em>
                  <em class="weui-form-preview__value color-orange" v-if="orderDetail.pay_status==3||orderDetail.pay_status==4">{{orderDetail.order_amount | numeral('$0,0.00')}}</em>
              </div>
          </div>
    </div>
    <br>
    <div class="weui-form-preview">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">人工费</label>
                  <em class="weui-form-preview__value">{{orderDetail.details.labor_cost | numeral('$0,0.00')}}</em>
              </div>
          </div>
          <div class="weui-form-preview__bd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">开始时间</label>
                  <span class="weui-form-preview__value">{{orderDetail.details.service_start_time | moment("HH:mm:ss")}}</span>
              </div>
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">结束时间</label>
                  <span class="weui-form-preview__value">{{orderDetail.details.service_end_time | moment("HH:mm:ss")}}</span>
              </div>
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">暂停时长</label>
                  <span class="weui-form-preview__value">{{orderDetail.details.service_pause_second}}秒</span>
              </div>
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">工作时长</label>
                  <span class="weui-form-preview__value">{{orderDetail.details.work_time}}</span>
              </div>
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">收费时长</label>
                  <span class="weui-form-preview__value">{{orderDetail.details.charge_time}}小时</span>
              </div>
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">搬家车型</label>
                  <span class="weui-form-preview__value">{{orderDetail.details.vehicle_type_name}}</span>
              </div>
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">服务人员</label>
                  <span class="weui-form-preview__value">{{orderDetail.cost_data.operates_num}}人</span>
              </div>
          </div>
    </div>
    <br>
    <div class="weui-form-preview">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">出车返程费</label>
                  <em class="weui-form-preview__value">{{orderDetail.details.return_trip_cost | numeral('$0,0.00')}}</em>
              </div>
          </div>
          <div class="weui-form-preview__bd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">搬出地址</label>
                  <span class="weui-form-preview__value">{{orderDetail.details.out_address.move_out_street}}, {{orderDetail.details.out_address.move_out_suburb}}, {{orderDetail.details.out_address.move_out_state}}, {{orderDetail.details.out_address.move_out_postcode}}</span>
              </div>
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">搬入地址</label>
                  <span class="weui-form-preview__value">{{orderDetail.details.in_address.move_in_street}}, {{orderDetail.details.in_address.move_in_suburb}}, {{orderDetail.details.in_address.move_in_state}}, {{orderDetail.details.in_address.move_in_postcode}}</span>
              </div>
          </div>
    </div>
    <br>
    <div class="weui-form-preview">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">楼梯费</label>
                  <em class="weui-form-preview__value">{{orderDetail.details.stairs_cost | numeral('$0,0.00')}}</em>
              </div>
          </div>
          <div class="weui-form-preview__bd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">搬出楼层</label>
                  <span class="weui-form-preview__value" id="move_out_floor_value">{{orderDetail.details.attribute.move_out_floor}}</span>
              </div>
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">搬入楼层</label>
                  <span class="weui-form-preview__value" id="move_in_floor_value">{{orderDetail.details.attribute.move_in_floor}}</span>
              </div>
          </div>
    </div>
    <br>
    <div class="weui-form-preview">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">重物费</label>
                  <em class="weui-form-preview__value">{{orderDetail.details.weight_cost | numeral('$0,0.00')}}</em>
              </div>
          </div>
          <div class="weui-form-preview__bd" id="move_valuables_text" v-if="Object.keys(this.orderDetail.details.attribute.move_valuables).length || orderDetail.details.attribute.move_other_valuables ">
              <div class="weui-form-preview__item"  v-for="(value, name) in orderDetail.details.attribute.move_valuables">
                  <label class="weui-form-preview__label">{{name}}</label>
                  <span class="weui-form-preview__value">x {{value}}</span>
              </div>
              <div class="weui-form-preview__item" v-if="orderDetail.details.attribute.move_other_valuables">
                  <label class="weui-form-preview__label">{{orderDetail.details.attribute.move_other_valuables}}</label>
                  <span class="weui-form-preview__value">特殊重物</span>
              </div>
          </div>
    </div>
    <br>
    <div class="weui-form-preview">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">Etoll高速费</label>
                  <em class="weui-form-preview__value">{{orderDetail.details.etoll_cost | numeral('$0,0.00')}}</em>
              </div>
          </div>
    </div>
    <br>
    <div class="weui-form-preview">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">GST费用 (10%)</label>
                  <em class="weui-form-preview__value">{{orderDetail.gst_amount | numeral('$0,0.00')}}</em>
              </div>
          </div>
    </div>
    <br>
    <div class="weui-form-preview">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">其他费用</label>
                  <em class="weui-form-preview__value">{{orderDetail.other_amount | numeral('$0,0.00')}}</em>
              </div>
          </div>
          <div class="weui-form-preview__bd" v-if="Object.keys(this.orderDetail.other_amount_data).length">
              <div class="weui-form-preview__item" v-for="item in orderDetail.other_amount_data">
                  <label class="weui-form-preview__label">{{item.name}}</label>
                  <span class="weui-form-preview__value" >{{item.price | numeral('$0,0.00')}}</span>
              </div>
          </div>
    </div>
    <br>
    <div class="weui-form-preview">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">优惠减免</label>
                  <em class="weui-form-preview__value">-{{orderDetail.offers_amount | numeral('$0,0.00')}}</em>
              </div>
          </div>
    </div>
    <br>
    <div class="btn-box-fix">
      <div class="btn-container">

		      <router-link  class="btn active" :to="orderURL">返回
          </router-link>
      </div>
    </div>

    <transition name="fade">
          <div id="loadingToast" v-show="isSending">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在获取订单</p>
              </div>
          </div>
    </transition>



  </div>


</template>

<script>
import qs from 'qs'

export default {
  name: 'order-detail',
  data () {
    return {
      isSending:false,
      isSendingPricing:false,
      isLeaving:false,
      pricing:{},
      orderDetail: {
          type_id: "",
          order_number: "",
          member_id: "",
          member_name: "",
          member_phone: "",
          member_mail: "",
          service_date:"",
          service_time: "",
          deposit_amount: "",
          offers_amount:"",
          payment_amount: "",
          order_amount: "",
          order_status: "",
          pay_status: "",
          prepaid_time:"",
          pay_time: "",
          type_name: "",
          details: {
              vehicle_type:"",
              move_scale:"",
              plate_number: "",
              estimated_time: "",
              in_address: {
                  move_in_name: "",
                  move_in_phone: "",
                  move_in_state: "",
                  move_in_suburb: "",
                  move_in_street: "",
                  move_in_postcode: ""
              },
              out_address: {
                  move_out_name: "",
                  move_out_phone: "",
                  move_out_state: "",
                  move_out_suburb: "",
                  move_out_street: "",
                  move_out_postcode: ""
              },
              pathway_address: [
                  {
                      name: "",
                      phone: "",
                      state: "",
                      suburb: "",
                      street: "",
                      postcode: "",
                      sort: ""
                  },
                  {
                      name: "",
                      phone: "",
                      state: "",
                      suburb: "",
                      street: "",
                      postcode: "",
                      sort: ""
                  }
              ],
              labor_cost: "",
              return_trip_cost: "",
              stairs_cost: "",
              weight_cost: "",
              etoll_cost: "",
              km: "",
              service_start_time: "",
              service_end_time: "",
              service_pause_time: null,
              service_pause_second:"",
              attribute: {
                  move_in_floor: "",
                  move_in_parking: "",
                  move_out_floor: "",
                  move_out_parking: "",
                  move_other_valuables: "",
                  move_valuables: {
                  }
              }
          }
      },
      order:{
        data:{
        }
      }
    }
  },
  methods: {
    getData(){
      if(this.isSending){
        return false;
      }
      else{
        let dataObject={};
        let that = this;
        this.isSending = true;
        dataObject.order_number = this.$route.query.id;
        dataObject.token = localStorage.token;

        this.axios.post(this.apiURL()+'/Order/orderInfo', qs.stringify(dataObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending = false;
            that.orderDetail = response.data.data;
          }
          else{
            if(!that.checkLogin()){
              that.$router.push('/login');
            }
            that.isSending=false;
          }
        })
        .catch(function (error) {
            console.log(error)
            alert("订单获取失败，请检查网络并重新尝试")
            that.isSending=false;
        });
      }
    },
    goback(){
      this.$router.push(this.orderURL);
    }
  },
  computed: {
    orderURL: function (){
      let theString = this.$route.query.id;
      return '/move/order-detail?id=' + theString;
    },
    move_valuables: function () {
      if(Object.keys(this.orderDetail.details.attribute.move_valuables).length){
        let result = '';
        let concatResult = '';
        let allValuables = Object.keys(this.orderDetail.details.attribute.move_valuables);
        concatResult = allValuables.join(", ");

        if(typeof this.order.data.move_other_valuables != "undefined"){
          concatResult = concatResult+this.order.data.move_other_valuables;
        }
        return concatResult;
      }
      else{
        return "无";
      }
    },
    service_period: function () {
      let result = '';
      switch (this.orderDetail.details.service_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("service_period conv error");
      }
      return result;
    },
  },
  created: function () {
    this.getData();

  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ {
  .weui-cell__ft{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width:70%;
    font-size:0.9em;
  }

  .weui-msg__title{
    font-size:1.1em;
    margin-bottom:0;
  }

  .park-assist{
      text-align:center;
      color:#fe9567;
  }

  .prepay-img{
    width:100%;
  }
} 

</style>



// WEBPACK FOOTER //
// src/pages/baggage/order-detail-price.vue